<template>
  <div class="bq-page" :class="{ 'bq-wireless-page': isMobile }">
    <banner
      class="bq-banner"
      type="horizontal"
      :cover="banner.cover"
      :mcover="banner.mcover"
    >
      <h1 slot="content" class="bq-banner-login">
        {{ banner.title.loginTitle }}
      </h1>
      <p slot="content" class="bq-banner-text">
        {{ banner.title.text }}
      </p>
      <button
        class="bq-banner-extra"
        @click="handleJump('/service')"
        slot="extra"
        v-if="!isMobile"
      >
        了解更多 <span>></span>
      </button>
    </banner>

    <!-- 解决方案 -->
    <box
      class="bq-box-service"
      :title="serviceData.title"
      :desc="serviceData.subtitle"
    >
      <div class="bq-solution-parent">
        <div class="bq-solution" ref="soluwrap">
          <horizontal-card
            v-for="(product, idx) in serviceData.products"
            :key="idx"
            :cover="product.img"
            :title="product.title"
            :link="product.path"
            :coverContent="product.desc"
          >
          </horizontal-card>
        </div>
        <el-button
          icon="el-icon-arrow-left"
          circle
          class="bq-left-btn"
          @click="handleSolutionBtn('left')"
        ></el-button>
        <el-button
          icon="el-icon-arrow-right"
          class="bq-right-btn"
          circle
          @click="handleSolutionBtn('right')"
        ></el-button>
      </div>
    </box>

    <!-- 产品 -->
    <box
      class="bq-box-product"
      :title="productData.title"
      :desc="productData.subtitle"
      v-if="!isMobile"
    >
      <div class="bq-mask-parent-wrap">
        <div class="bq-mask-parent">
          <div class="bq-mask-cardWrap" ref="wrap">
            <slide-card
              class="bq-mask-card"
              v-for="(item, idx) in productData.products"
              :key="idx"
              :icon="item.icon"
              :title="item.title"
              :img="item.img"
              :coverImg="item.coverImg"
              :desc="item.desc"
              :index="idx"
              :num="productData.products.length"
            >
            </slide-card>
          </div>
        </div>
        <el-button
          icon="el-icon-arrow-left"
          circle
          class="bq-left-btn"
          @click="handleRight('left')"
        ></el-button>
        <el-button
          icon="el-icon-arrow-right"
          class="bq-right-btn"
          circle
          @click="handleRight('right')"
        ></el-button>
      </div>
    </box>
    <!-- 新闻动态 -->
    <box
      class="bq-box-news"
      :title="newsData.title"
      :desc="newsData.subtitle"
      v-if="!isMobile"
    >
      <div class="bq-row">
        <card
          :class="!isMobile ? 'bq-box-left-item' : 'bq-box-item'"
          layout="vertical"
          size="large"
          :cover="newsData.news[0].cover"
          :title="isMobile ? newsData.news[0].title : ''"
          isLink
          :link="newsData.news[0].path"
        >
          <h3 class="bq-box-item-title" slot="title" v-if="!isMobile">
            {{ newsData.news[0].title }}
          </h3>
          <p slot="content" v-if="isMobile">{{ newsData.news[0].desc }}</p>
        </card>

        <div :class="{ 'bq-box-right-wrapper': !isMobile }">
          <card
            class="bq-box-item"
            :layout="!isMobile ? 'horizontal' : 'vertical'"
            size="default"
            v-for="(item, index) in newsData.news.slice(1, 3)"
            :key="index"
            :cover="item.cover"
            :title="item.title"
            isLink
            :link="item.path"
          >
            <p class="bq-box-item-content" slot="content">{{ item.desc }}</p>
          </card>
        </div>
      </div>
    </box>
    <!-- 合作伙伴 -->
    <box class="bq-box-patter" title="合作伙伴" desc="parthenship">
      <div>
        <ul>
          <li
            v-for="(item, index) in patterData"
            :key="index"
            @click="toggleTabs(item.id)"
            :class="activeIndex === item.id ? 'active' : 'normal'"
            class="bq-patter-header"
          >
            {{ item.title }}
          </li>
        </ul>
        <div
          v-for="(item, index1) in patterData"
          :key="index1"
          v-show="activeIndex === item.id"
          class="bq-patter-list-wrap"
        >
          <div
            v-for="(item, idx) in item.patter"
            :key="idx"
            class="bq-patter-list"
          >
            <img
              :src="item.icon"
              alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
            />
            <p>{{ item.title }}</p>
          </div>
        </div>
      </div>
    </box>
  </div>
</template>

<script>
import Vue from 'vue';
import { Swipe, SwipeItem } from 'vant';
import Banner from '@/components/newwebsite/Banner';
import Box from '@/components/newwebsite/Box';
import HorizontalCard from '@/components/newwebsite/HorizontalCard';
import SlideCard from '@/components/newwebsite/SlideCard';
import Card from '@/components/newwebsite/Card';
import { isWirelessDevice } from '../../../utils/utils';
import { patterData } from './map';

import { banner } from './home.js';
import { serviceData } from '../Service/service.js';
import { productData } from '../Product/product.js';
import { aboutData } from '../About/about.js';
import { newsData } from '../News/news.js';

Vue.use(Swipe).use(SwipeItem);
let Index = 0;
let soluIndex = 0;
const PWIDTH = 252;
const PMARGIN = 20;
const SWIDTH = 296;
const SMARGIN = 32;

export default {
  name: 'home',

  components: {
    Box,
    Banner,
    HorizontalCard,
    SlideCard,
    Card,
  },

  data() {
    return {
      isMobile: false,
      banner,
      serviceData,
      productData,
      aboutData,
      newsData,
      patterData,
      currentNews: 1,
      currentAbout: 1,
      activeIndex: '1',
    };
  },

  created() {
    this.isMobile = isWirelessDevice();
  },

  methods: {
    handleJump(path) {
      location.href = path;
    },

    onNewsChange(index) {
      this.currentNews = index + 1;
    },

    onAboutChange(index) {
      this.currentAbout = index + 1;
    },
    toggleTabs(index) {
      this.activeIndex = index;
      console.log(this.activeIndex, index);
    },
    handleRight(position) {
      if (position === 'left' && Index === 0) {
        this.$refs.wrap.style.left = `${-(PWIDTH * 1 + PMARGIN * 1)}px`;
        Index = Index - 1;
      } else if (position === 'left' && Index === -1) {
        this.$refs.wrap.style.left = `${-(PWIDTH * 6 + PMARGIN * 6)}px`;
        Index = Index - 1;
      } else if (position === 'left' && Index === -2) {
        this.$refs.wrap.style.left = `${0}px`;
        Index = 0;
      } else if (position === 'left' && Index === 1) {
        this.$refs.wrap.style.left = `${0}px`;
        Index = 0;
      } else if (position === 'left' && Index === 2) {
        this.$refs.wrap.style.left = `${-(PWIDTH * 1 + PMARGIN)}px`;
        Index = -1;
      } else if (position === 'right' && Index === 0) {
        this.$refs.wrap.style.left = `${-(PWIDTH * 6 + PMARGIN * 6)}px`;
        Index = Index + 1;
      } else if (position === 'right' && Index === 1) {
        this.$refs.wrap.style.left = `${-(PWIDTH + PMARGIN)}px`;
        Index = Index + 1;
      } else if (position === 'right' && Index === 2) {
        this.$refs.wrap.style.left = `${0}px`;
        Index = 0;
      } else if (position === 'right' && Index === -1) {
        this.$refs.wrap.style.left = `${0}px`;
        Index = 0;
      } else if (position === 'right' && Index === -2) {
        this.$refs.wrap.style.left = `${-(PWIDTH + PMARGIN)}px`;
        Index = -1;
      }
    },
    handleSolutionBtn(position) {
      if (position === 'left' && soluIndex === 0) {
        this.$refs.soluwrap.style.left = `${-(SWIDTH * 2 + SMARGIN * 2)}px`;
        soluIndex = soluIndex - 1;
      } else if (position === 'left' && soluIndex === -1) {
        this.$refs.soluwrap.style.left = `${0}px`;
        soluIndex = 0;
      } else if (position === 'left' && soluIndex === 1) {
        this.$refs.soluwrap.style.left = `${0}px`;
        soluIndex = 0;
      } else if (position === 'right' && soluIndex === 0) {
        this.$refs.soluwrap.style.left = `${-(SWIDTH * 2 + SMARGIN * 2)}px`;
        soluIndex = soluIndex + 1;
      } else if (position === 'right' && soluIndex === 1) {
        this.$refs.soluwrap.style.left = `${0}px`;
        soluIndex = 0;
      } else if (position === 'right' && soluIndex === -1) {
        this.$refs.soluwrap.style.left = `${0}px`;
        soluIndex = 0;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
